import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Шапка карточки ленты (запрос агента, «Меняет черновик», проект; мокап Main.dc.html, `.card-hd`): иконка, заголовок
 * и бейдж. Иконка стоит у первой строки заголовка; длинный заголовок переносится рядом с ней, бейдж — за ним, в узкой
 * панели — строкой ниже.
 */
export function CardHead({
  icon: Icon,
  id,
  title,
  badge,
}: {
  icon: LucideIcon;
  id: string;
  title: string;
  badge: ReactNode;
}) {
  return (
    <div className="flex items-start gap-2">
      <Icon size={16} strokeWidth={1.75} className="mt-[3px] shrink-0 text-ink-2" aria-hidden />
      <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
        <h3 id={id} className="min-w-0 text-[15px] font-semibold break-words text-ink">
          {title}
        </h3>
        {badge}
      </div>
    </div>
  );
}
